import React, { useState } from 'react'

import {
  Box,
  Divider,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography
} from '@mui/material'
import { ButtonWithIcon } from 'components/Buttons/ButtonWithIcon'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { SelectQBankProps } from './types'
import useAuthStore from 'store/userStore'

const defaultText = 'No QBank Selected'

export const SelectQBank: React.FC<SelectQBankProps> = ({ qbanks }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const { user } = useAuthStore()

  return (
    <Stack flexDirection={'row'} alignItems={'center'} gap={2}>
      <Tooltip title={defaultText} arrow placement="bottom">
        <Typography
          variant="h6"
          sx={(theme) => {
            return {
              maxWidth: '150px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }}
        >
          {user?.question_bank_id}
        </Typography>
      </Tooltip>
      <ButtonWithIcon aria-describedby={id} onClick={handleClick}>
        <ChevronDown />
      </ButtonWithIcon>
      <Menu
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Stack
          sx={(theme) => {
            return {
              maxHeight: '200px',
              overflowY: 'auto',
              minWidth: '200px',
              '::-webkit-scrollbar': {
                display: 'none'
              }
            }
          }}
        >
          {qbanks.length > 0 &&
            qbanks.map((qbank) => (
              <MenuItem key={qbank.qbank_id} onClick={handleClose}>
                {qbank.name}
              </MenuItem>
            ))}
          {qbanks.length <= 0 && (
            <Typography px={2} py={2} variant="body1">
              {defaultText}
            </Typography>
          )}
        </Stack>
        <Divider />
        <Box py={1} px={2}>
          <Typography
            variant="body1"
            component={NavLink}
            to="/dashboard/enrollments"
            onClick={handleClose}
            sx={{
              textDecoration: 'none',
              alignItems: 'center',
              display: 'inline-flex'
            }}
          >
            All Enrollments <ChevronRight size={20} />
          </Typography>
        </Box>
      </Menu>
    </Stack>
  )
}
